import React from 'react'
import { useClientPage } from './hook'
import { MainTemplate } from '../../templates/MainTemplate'
import { TableTemplate } from '../../templates/TableTemplate'
import { DetailClientModal } from '../../organisms/modal/DetailClientModal'
import { SearchBar } from '../../atoms/SearchBar'
import { Client } from '../../../ducks/client/types'
import { Resource, Permission } from '../../../constants/permissions'
import { useClientToast } from './hook';
import { Toast } from '../../atoms/Toast';
import styled from 'styled-components';

export const ClientPage = () => {
  const { showToast, toast, hideToast } = useClientToast();
  const {
    tableHeaders,
    clients,
    fetchDataFunction,
    isDetailModalOpen,
    selectedClient,
    handleOpenDetailModal,
    handleCloseDetailModal,
    searchTerm,
    handleSearchChange,
    page,
    pageSize,
    totalItems,
    hasPagination,
    handlePageChange,
  } = useClientPage(showToast);

  return (
    <>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <MainTemplate
        title='Clients'
        useFitHeight
      >
      <SearchBar
        searchValue={searchTerm}
        onSearchChange={handleSearchChange}
        placeholder="Search by inquiry number and name ..."
      />
      <StyledTableWrapper>
        <TableTemplate<Client & { no: number }>
          headers={tableHeaders}
          data={clients}
          fetchDataFunction={fetchDataFunction}
          columnWidths={["5%", "13%", "25%", "10%", "13%", "27%", "7%"]} // Read: 8%, No: 10%, Name: 25%, ...
          hasPagination={hasPagination}
          perPage={pageSize}
          total={totalItems}
          currentPage={page}
          defaultSort={{ field: 'inquiry_number', order: 'asc' }}
          editable
          resource={Resource.CLIENTS}
          onPermissionError={showToast}
          onEdit={() => { }}
          stickyHeader
          onSetPage={handlePageChange}
        />
      </StyledTableWrapper>
      {selectedClient && isDetailModalOpen && (
        <DetailClientModal
          isOpen={isDetailModalOpen}
          onClose={handleCloseDetailModal}
          client={selectedClient}
        />
      )}
      </MainTemplate>
    </>
  )
}

const StyledTableWrapper = styled.div`
  margin-top: 20px;
  
  @media (max-width: 768px) {
    margin-top: 16px;
  }

  @media (max-width: 480px) {
    margin-top: 12px;
  }
`;
